import type { PropsWithChildren } from "react";
import type { FilesContextValue } from "./FilesContext";
import { FilesContext } from "./FilesContext";

export const FilesContextProvider = ({ children, ...value }: PropsWithChildren<FilesContextValue>) => {
  return <FilesContext value={value}>{children}</FilesContext>;
};
